var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import NukaCarousel from 'nuka-carousel';
import { Children } from 'react';
import { CarouselWrapper, Oval, OvalBox, SliderContainer } from './styles';
export var Carousel = function (_a) {
  var children = _a.children,
    props = __rest(_a, ["children"]);
  return _jsx(CarouselWrapper, {
    children: _jsx(NukaCarousel, __assign({
      slidesToShow: 1,
      defaultControlsConfig: {
        nextButtonStyle: {
          display: 'none'
        },
        prevButtonStyle: {
          display: 'none'
        }
      },
      renderBottomCenterControls: function (_a) {
        var currentSlide = _a.currentSlide,
          goToSlide = _a.goToSlide;
        return _jsx(SliderContainer, {
          children: Children.map(children, function (_, index) {
            return _jsx(OvalBox, {
              onClick: function () {
                return goToSlide(index);
              },
              children: _jsx(Oval, {
                className: "active-slide-cta",
                highlighted: index === currentSlide
              })
            }, index);
          })
        });
      }
    }, props, {
      children: children
    }))
  });
};